import { render, staticRenderFns } from "./ImportFromOrderForm.vue?vue&type=template&id=2b41022f"
import script from "./ImportFromOrderForm.vue?vue&type=script&lang=js"
export * from "./ImportFromOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports